module.exports = __webpack_public_path__ + "assets/images/book_b2048f2c49cd62857ffbc114ba9cceb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/locales/sudeste/book.png
// module id = 204
// module chunks = 0